/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { FILE_UPLOAD } from '@engine/actions/action-types';
export var showProgress = function showProgress(inputName, bool) {
  return {
    type: FILE_UPLOAD(inputName).showProgress,
    data: bool
  };
};
export var percentLoaded = function percentLoaded(inputName, percent) {
  return {
    type: FILE_UPLOAD(inputName).percentLoaded,
    data: percent
  };
};
export var setResponse = function setResponse(inputName, response) {
  return {
    type: FILE_UPLOAD(inputName).setResponse,
    data: response
  };
};
export var reset = function reset(inputName) {
  return {
    type: FILE_UPLOAD(inputName).uploadReset
  };
};
export function resetMessage(name) {
  return function (dispatch) {
    dispatch(reset(name));
  };
}

function dispatchResponse(name, res, dispatch) {
  var PROGRESS_BAR_DELAY = 1000;
  setTimeout(function () {
    dispatch(setResponse(name, res));
    dispatch(showProgress(name, false));
    dispatch(percentLoaded(name, 0));
  }, PROGRESS_BAR_DELAY);
}

function upload(name, url, body, dispatch) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url);

    xhr.onload = function () {
      return resolve(xhr.response);
    };

    xhr.onerror = function () {
      return reject(xhr);
    };

    xhr.upload.onprogress = function (event) {
      var MAX_PERCENT = 100;
      var progress = Math.round(event.loaded / event.total * MAX_PERCENT) || 0;
      dispatch(percentLoaded(name, progress));
    };

    xhr.send(body);
  });
}

export function uploadFile(requestUrl, inputName, filePayload) {
  var data = new FormData();
  data.append(inputName, filePayload);
  data.append('authenticity_token', window.CSRF);
  return function (dispatch) {
    dispatch(showProgress(inputName, true));
    return upload(inputName, requestUrl, data, dispatch).then(function (response) {
      return JSON.parse(response);
    }).then(function (response) {
      dispatchResponse(inputName, response, dispatch);

      if (response.redirect) {
        var RESPONSE_MESSAGE_DELAY = 5000;
        setTimeout(function () {
          window.location.replace(response.redirect);
        }, RESPONSE_MESSAGE_DELAY);
      }
    })["catch"](function () {
      dispatchResponse(inputName, {
        data: I18n.t('javascript.errors.something_went_wrong')
      }, dispatch);
    });
  };
}